module.exports = __webpack_public_path__ + "healthcare.svg?827b7af8c8d497ba656a8ecd08e8bdfd";


//////////////////
// WEBPACK FOOTER
// ./public/img/products/healthcare.svg
// module id = 564
// module chunks = 3